import CopyLinkField, { CopyLinkFieldProps } from './CopyLinkField';

export type { CopyLinkFieldProps };
export default CopyLinkField;
